import {
  apiGetUserSchool,
  apiUpdateSchoolDetails
} from '../../common/api/school'

import {
  apiConnectToWonde,
  apiDisconnectFromWonde,
  apiPullFromWonde,
  apiSearchWondeSchools,
  apiRequestGroupCallAccess
} from '../../common/api/wonde'

const fetchSchoolData = schoolId => ({
  requestPrefix: 'SCHOOL_DATA:FETCH',
  params: { schoolId },
  request: () =>
    apiGetUserSchool({
      include:
        'account.teacher_type.school,account.teacher_type.school.names,account.teacher_type.school.wonde,account.teacher_type.school.groupcall'
    })
})

const connectToWonde = (schoolId, wondeId) => ({
  requestPrefix: 'SCHOOL_DATA:CONNECT',
  request: () => apiConnectToWonde(schoolId, wondeId)
})

const disconnectFromWonde = schoolId => ({
  requestPrefix: 'SCHOOL_DATA:DISCONNECT',
  request: () => apiDisconnectFromWonde(schoolId)
})

const pullFromWonde = schoolId => ({
  requestPrefix: 'SCHOOL_DATA:PULL',
  request: () => apiPullFromWonde(schoolId)
})

const updateParentsPulling = (schoolId, data) => ({
  requestPrefix: 'SCHOOL_DATA:PARENTS',
  params: data,
  request: () => apiUpdateSchoolDetails(schoolId, data)
})

const searchWondeSchoolsToRequest = searchTerm => ({
  requestPrefix: 'SCHOOL_DATA:FETCHING_SCHOOLS',
  params: { searchTerm },
  request: () =>
    apiSearchWondeSchools({
      include: 'school.names,school.urn',
      term: searchTerm,
      limit: 20
    })
})

const requestGroupCallAccess = schoolId => ({
  requestPrefix: 'SCHOOL_DATA:REQUEST_GROUPCALL',
  request: () => apiRequestGroupCallAccess(schoolId)
})

export {
  fetchSchoolData,
  connectToWonde,
  disconnectFromWonde,
  pullFromWonde,
  updateParentsPulling,
  searchWondeSchoolsToRequest,
  requestGroupCallAccess
}
